// extracted by mini-css-extract-plugin
export var consultingContainer = "Consulting-module--consulting-container--6302e";
export var consultingWrapper = "Consulting-module--consulting-wrapper--9fb74";
export var contactForm = "Consulting-module--contactForm--d8768";
export var disabledMarginTop = "Consulting-module--disabled-margin-top--9c4f4";
export var features = "Consulting-module--features--0a4ae";
export var greeting = "Consulting-module--greeting--310d6";
export var lightVariant = "Consulting-module--light-variant--88e13";